const guard = {
    invalid_input: '{{type}} 요청 타입은 유효하지 않아요.',
    invalid_pagination: '요청의 Pagination 값이 유효하지 않아요.',
    can_not_get_tenant_id: '요청에서 테넌트 ID를 가져올 수 없습니다.',
    file_size_exceeded: '파일 크기가 초과되었습니다.',
    mime_type_not_allowed: 'MIME 타입이 허용되지 않습니다.',
};
export default guard;
